import { Injectable } from '@angular/core';
import { arrayNotEmpty } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection, getCurrentUser, setOnLocal } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { environment } from 'src/environments/environment';
import { SerProperty } from '../models/property.model';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

  private TABLA_PRINCIPAL: string = "ser_properties"

  constructor(
    private queriesService: QueriesService,
  ) { }

  async findAll(where: SerProperty = {}, asArray: boolean = false): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL)
      .select("TO_CHAR(id) as id", "key", "valor", "estado")
      .where({ ...where })
      .orderBy("key asc")
      .execute()
    result.data = result.data ? result.data : undefined
    if (result.success && result.data && arrayNotEmpty(result.data) && !asArray) {
      const endpoints = {}
      result.data.forEach(endpoint => {
        endpoints[endpoint.key] = endpoint.valor
      });
      setOnLocal(environment.LOCAL_ENDPOINTS, endpoints)
      result.data = endpoints
    }
    return result
  }

  async findOne(key: string, where: SerProperty = {}): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).where({ key, ...where }).execute()
    result.data = arrayNotEmpty(result.data) ? result.data[0] : null
    result.data.id = Number(result.data.id)
    return result
  }

  async create(value: SerProperty): Promise<BasicResponse> {
    const idResult = await this.queriesService.table(this.TABLA_PRINCIPAL).select("(TO_CHAR(MAX(id))+1) as id").execute()
    value.id = Number(idResult.data[0].id)
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).insert({ ...value, usuario_creacion: getCurrentUser().usuario_aplicativo }).execute()
    return result
  }

  async update(value: SerProperty, where: SerProperty) {
    const { key, estado, valor } = value
    where.id = Number(where.id)
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).update({ key, estado, valor, usuario_modificacion: getCurrentUser().usuario_aplicativo }, where, 1).execute()
    return result
  }
}
